<template>
  <div class="weekly-variables-summary card-box">
    <div class="card-content current-week">
      <div class="title">
        כמה כסף נשאר להוציא על הוצאות משתנות השבוע?
      </div>
      <div class="remaining-variables out-of-date">
        <animated-number :value="remainingVariables"></animated-number> ₪
      </div>
    </div>
    <div class="next-week-remaining" v-if="showNextWeek">
      <div class="card-content next-week">
        <div>הוצאות משתנות של שבוע הבא&nbsp;</div>
        <div class="next-week-amount">{{ formatAmountWithFractionAndCurrency(nextWeekRemainingVariables)}}</div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import TransactionDisplayUtils from '../../generic-components/TransactionDisplayUtils.vue';
import cashflowViewConsts from '../../../../../../../../constants/cashflow-view';
import AnimatedNumber from '../../../../../../../../base-components/AnimatedNumber.vue';

export default {
  name: 'WeeklyVariablesSummary',
  mixins: [TransactionDisplayUtils],
  components: {
    AnimatedNumber,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    ...mapGetters('cashflowView', ['budgetUpdatedAt']),
    updateTime() {
      return moment(this.budgetUpdatedAt).format('DD.M.YY, H:mm');
    },
    weeks() {
      return this.cashflowUITree[cashflowViewConsts.cashflowTypes.variableExpense].weekly.realExpenses.categories;
    },
    currentWeek() {
      return _.find(this.weeks, w => w.timeFrameDetails.isCurrentWeek);
    },
    hasNextWeek() {
      if (this.currentWeek) {
        return this.currentWeek.weekIndex < this.weeks.length - 1;
      }
      return false;
    },
    showNextWeek() {
      return this.hasNextWeek && this.remainingVariables <= 0;
    },
    remainingVariables() {
      return this.currentWeek ? this.currentWeek.remaining : NaN;
    },
    nextWeekRemainingVariables() {
      return this.hasNextWeek ? this.weeks[this.currentWeek.weekIndex + 1].remaining : 0;
    },
    hasRemainingVariables() {
      return this.remainingVariables > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .weekly-variables-summary {
    font-family: SimplerPro;
    margin-bottom: 16px;

    .current-week {
      flex-direction: column;
    }

    .card-content {
      padding: 8px 18px 18px 18px;
      display: flex;

    }

    .next-week {
      padding: 18px;
      flex-direction: row;
    }

    .title {
      margin-bottom: 6px;
      color: $riseup_gray_2;
      font-family: GretaSans;
      font-size: 24px;
      line-height: 1em;
    }

    .remaining-variables {
      font-size: 46px;
      color: $riseup_black;
      margin: 16px 0px 2px 0px;

      &.out-of-date {
        color: $riseup_gray_2;
        font-weight: bold;
      }
    }

    .next-week-remaining {
      border-top: solid 1px $riseup_gray_1;
      font-size: 16px;
      color: $riseup_gray_2;
    }

    .next-week-amount {
      font-weight: bold;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/out-of-date-month/components/WeeklyVariablesSummary.vue